const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    backgroundColor: "white",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: 45,
    px: 2,
    py: "14px",
    borderBottom: "1px solid #f3f4f6",
    flexShrink: 0,
  },
  backButton: {
    display: "flex",
    alignItems: "center",
    gap: 0.75,
    color: "#6a7282",
    fontSize: 12,
    fontWeight: 500,
    textTransform: "none",
    minWidth: 0,
    p: 0,
    "&:hover": {
      backgroundColor: "transparent",
      color: "#364153",
    },
  },
  backIcon: {
    fontSize: 13,
  },
  title: {
    fontSize: 12,
    fontWeight: 600,
    color: "#1e2939",
    lineHeight: "16px",
  },
  summary: {
    px: 2,
    pt: "10px",
    pb: "11px",
    borderBottom: "1px solid #f3f4f6",
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  summaryRow: {
    display: "flex",
    alignItems: "baseline",
    gap: "6px",
  },
  summaryCount: {
    fontSize: 24,
    fontWeight: 700,
    color: "#1b4332",
    lineHeight: "24px",
  },
  summaryLabel: {
    fontSize: 12,
    fontWeight: 500,
    color: "#364153",
    lineHeight: "16px",
  },
  summaryMeta: {
    fontSize: 11,
    color: "#99a1af",
    lineHeight: "16.5px",
  },
  summarySubtitle: {
    fontSize: 10,
    fontWeight: 500,
    color: "#2d7a50",
    lineHeight: "15px",
    letterSpacing: "0.1172px",
  },
  wishlistSection: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    borderBottom: "1px solid #f3f4f6",
    flexShrink: 0,
  },
  wishlistNotice: {
    all: "unset",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    width: "100%",
    px: 2,
    py: "10px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#f4fbf7",
    },
  },
  wishlistNoticeIcon: {
    fontSize: 11,
    color: "#2d7a50",
    flexShrink: 0,
  },
  wishlistNoticeText: {
    flex: 1,
    textAlign: "left",
    fontSize: 11,
    fontWeight: 500,
    color: "#2d7a50",
    lineHeight: "16.5px",
    letterSpacing: "0.0645px",
  },
  wishlistNoticeChevron: {
    fontSize: 12,
    color: "#2d7a50",
    flexShrink: 0,
  },
  wishlistLink: {
    all: "unset",
    boxSizing: "border-box",
    alignSelf: "flex-start",
    px: 2,
    pb: "9px",
    fontSize: 11,
    fontWeight: 500,
    color: "#2d7a50",
    cursor: "pointer",
    textDecoration: "underline",
    textUnderlineOffset: "2px",
    "&:hover": {
      color: "#1f5b3a",
    },
  },
  wishlistSubtitle: {
    px: 2,
    pb: "8px",
    fontSize: 10,
    color: "#99a1af",
    lineHeight: "15px",
    letterSpacing: "0.1172px",
  },
  wishlistBrandScroll: {
    display: "flex",
    flexDirection: "column",
    maxHeight: 160,
    overflowY: "auto",
  },
  wishlistBrandRow: {
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    width: "100%",
    px: 2,
    pt: "9px",
    pb: "8px",
    borderTop: "1px solid #f9fafb",
    backgroundColor: "rgba(249,250,251,0.5)",
  },
  wishlistBrandIconCircle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 24,
    height: 24,
    borderRadius: "50%",
    backgroundColor: "#eaf5ee",
    flexShrink: 0,
  },
  wishlistBrandIcon: {
    fontSize: 10,
    color: "#2d7a50",
  },
  wishlistBrandName: {
    minWidth: 0,
    fontSize: 11,
    color: "#6a7282",
    lineHeight: "16.5px",
    letterSpacing: "0.0645px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  optedOutNotice: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    width: "100%",
    px: 2,
    py: "10px",
    borderBottom: "1px solid #f3f4f6",
    backgroundColor: "#fdf6ec",
    flexShrink: 0,
  },
  optedOutNoticeHeader: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  optedOutNoticeIcon: {
    fontSize: 11,
    color: "#b7791f",
    flexShrink: 0,
  },
  optedOutNoticeText: {
    flex: 1,
    textAlign: "left",
    fontSize: 11,
    fontWeight: 500,
    color: "#92600c",
    lineHeight: "16.5px",
    letterSpacing: "0.0645px",
  },
  optedOutList: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    pl: "19px",
  },
  optedOutItem: {
    fontSize: 11,
    color: "#92600c",
    lineHeight: "16.5px",
  },
  optedOutItemBrand: {
    fontWeight: 600,
  },
  brandList: {
    flex: 1,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
  },
  emptyText: {
    p: 3,
    textAlign: "center",
    fontSize: 12,
    color: "#99a1af",
  },
  brandRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    px: "12px",
    py: "8px",
    borderBottom: "1px solid #f9fafb",
    minHeight: 41,
  },
  brandAvatar: {
    width: 24,
    height: 24,
    fontSize: 8,
    fontWeight: 700,
    color: "#4a5565",
    flexShrink: 0,
  },
  brandInfo: {
    width: 88,
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
  },
  brandName: {
    fontSize: 11,
    fontWeight: 600,
    color: "#101828",
    lineHeight: "13.75px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  brandHandle: {
    fontSize: 9,
    color: "#99a1af",
    lineHeight: "11.25px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  divider: {
    width: "1px",
    height: 24,
    backgroundColor: "#f3f4f6",
    flexShrink: 0,
  },
  contactCell: {
    flex: 1,
    minWidth: 0,
  },
  contactButton: {
    all: "unset",
    boxSizing: "border-box",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    p: 0,
    "&:hover .contact-name": {
      color: "#1b4332",
    },
  },
  contactButtonContent: {
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: 0,
  },
  contactNameRow: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  contactName: {
    fontSize: 11,
    fontWeight: 500,
    color: "#1e2939",
    lineHeight: "13.75px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  bentoTag: {
    display: "inline-flex",
    alignItems: "center",
    gap: "3px",
    backgroundColor: "#eaf5ee",
    border: "1px solid #c6e6d0",
    borderRadius: "9999px",
    px: "5px",
    py: 0,
    height: 12,
    fontSize: 8,
    fontWeight: 500,
    color: "#2d7a50",
    lineHeight: 1,
    flexShrink: 0,
  },
  bentoTagIcon: {
    fontSize: 7,
    color: "#2d7a50",
  },
  yoursTag: {
    display: "inline-flex",
    alignItems: "center",
    gap: "3px",
    backgroundColor: "#eaf2fc",
    border: "1px solid #c6d8ee",
    borderRadius: "9999px",
    px: "5px",
    py: 0,
    height: 12,
    fontSize: 8,
    fontWeight: 500,
    color: "#1d4ed8",
    lineHeight: 1,
    flexShrink: 0,
  },
  yoursTagIcon: {
    fontSize: 7,
    color: "#1d4ed8",
  },
  contactEmail: {
    fontSize: 9,
    fontFamily: "Menlo, monospace",
    color: "#99a1af",
    lineHeight: "11.25px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  contactChevron: {
    fontSize: 11,
    color: "#99a1af",
    flexShrink: 0,
    ml: "4px",
  },
  contactEmpty: {
    width: "100%",
  },
  contactEmptyText: {
    fontSize: 11,
    fontStyle: "italic",
    color: "#99a1af",
  },
  contactMenu: {
    maxWidth: 280,
    border: "1px solid #e5e7eb",
    boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
  },
  contactMenuItem: {
    fontSize: 12,
    py: "6px",
    px: "10px",
    alignItems: "flex-start",
  },
  contactMenuName: {
    fontSize: 12,
    fontWeight: 600,
    color: "#1e2939",
    lineHeight: 1.3,
  },
  contactMenuEmail: {
    fontSize: 11,
    fontFamily: "Menlo, monospace",
    color: "#6a7282",
    lineHeight: 1.3,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  removeButton: {
    color: "#99a1af",
    width: 24,
    height: 24,
    "&:hover": {
      backgroundColor: "#f9fafb",
      color: "#6a7282",
    },
  },
  removeIcon: {
    fontSize: 11,
  },
  footer: {
    px: 2,
    pt: "13px",
    pb: "8px",
    borderTop: "1px solid #f3f4f6",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    flexShrink: 0,
  },
  nameInput: {
    "& .MuiInputBase-root": {
      borderRadius: "10px",
      backgroundColor: "white",
      border: "1px solid #e5e7eb",
      height: 34,
      px: "12px",
      fontSize: 12,
      "&.Mui-focused": {
        borderColor: "#1b4332",
      },
    },
    "& .MuiInputBase-input": {
      p: 0,
      color: "#1e2939",
      "&::placeholder": {
        color: "rgba(10,10,10,0.5)",
        opacity: 1,
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
  },
  saveAndPitchButton: {
    width: "100%",
    height: 36,
    borderRadius: "14px",
    backgroundColor: "#1b4332",
    color: "white",
    fontSize: 12,
    fontWeight: 500,
    textTransform: "none",
    gap: 0.75,
    "&:hover": {
      backgroundColor: "#163528",
    },
    "&.Mui-disabled": {
      backgroundColor: "#1b4332",
      color: "white",
      opacity: 0.4,
    },
  },
  saveAndPitchIcon: {
    fontSize: 13,
  },
  justSaveButton: {
    height: 28.5,
    color: "#99a1af",
    fontSize: 11,
    fontWeight: 500,
    textTransform: "none",
    letterSpacing: "0.0645px",
    "&:hover": {
      backgroundColor: "transparent",
      color: "#6a7282",
    },
    "&.Mui-disabled": {
      color: "#99a1af",
      opacity: 0.5,
    },
  },
};

export default styles;
